module.exports = __webpack_public_path__ + "img/btc.ed419759.svg";